/**
 * Feature main component Quotation
 *
 * @author Pablo Puppo <pablo@gestionaleauto.com>
 */

/**
 * Main
 */
import React, { useEffect } from 'react';
import HttpStatus from 'http-status-codes';
/**
 * Material UI
 */
import { makeStyles } from '@mui/styles';

/**
 * Redux
 */
import { useDispatch, useSelector } from 'react-redux';
import { loadConfiguration, saveAttachmentTypes } from '../redux/lookupsSlice';
import { leadState, updateQuoteData } from '../redux/leadSlice';

/**
 * Components
 */
import WizardQuotation from './WizardQuotation';
import api from '../helpers/api';

const useStyles = makeStyles((theme) => ({
  grid: {
    display: 'flex',
    width: '100%',
    maxWidth: '1366px',
    flexDirection: 'column-reverse',
    height: 'auto',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'space-between',
      flexDirection: 'row',
    },
  },
  child: {
    width: '100%',
    marginBottom: 20,
    [theme.breakpoints.up('md')]: {
      maxWidth: '536px',
      marginBottom: 0,
    },
  },
}));

/**
 * @returns {JSX.Element}
 */
function QuotationFrontend() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { cookie } = useSelector(leadState);

  /**
   * Get AttachmentTypes data from api
   */
  const getAttachmentTypes = async () => {
    const res = await api.get({
      entryPoint: '/attachment_types',
      silentFail: true,
      auth: false,
    });
    if (res?.status === HttpStatus.OK) {
      dispatch(saveAttachmentTypes(res.data.attachment_types));
    }
  };

  useEffect(() => {
    dispatch(loadConfiguration({ configuration: window?.quotationData }));
    getAttachmentTypes();
  }, []);

  useEffect(() => {
    if (cookie && cookie.makeId && cookie.makeId !== '') {
      dispatch(updateQuoteData({ ...cookie }));
    }
  }, [cookie]);

  return (
    <div className={classes.grid}>
      <div className={classes.child}>
        <WizardQuotation />
      </div>
    </div>
  );
}

export default QuotationFrontend;
